export enum TagsColor {
  Yellow = "yellow", //زرد
  Red = "#ff4347", //قرمز
  Orange = "#ff8800", //نارنجی
  Green = "#3da000", //سبز
  Blue = "#1755c4", //آبی
  Purple = "#c15aff", //بنفش
  Black = "black", //سیاه
}

export const ListOfTagsColor = [
  { label: "زرد", value: TagsColor.Yellow },
  { label: "قرمز", value: TagsColor.Red },
  { label: "نارنجی", value: TagsColor.Orange },
  { label: "سبز", value: TagsColor.Green },
  { label: "آبی", value: TagsColor.Blue },
  { label: "بنفش", value: TagsColor.Purple },
  { label: "سیاه", value: TagsColor.Black },
];
